import { localStorageFactory } from 'services/localStorage/localStorage.factory';
import { StartPage } from 'types/startPage';

export const [DefaultStartPageContext, DefaultStartPageProvider] = localStorageFactory<StartPage>(
  'default-start-page',
  'start'
);
